// Piece values across different board sizes from Tables 5-3A and 5-3B
export interface BoardSizeValue {
  boardSize: string;
  value: number;
}

export const PIECE_VALUES: Record<string, BoardSizeValue[]> = {
  EPS: [ // Empress
    { boardSize: '8×8', value: 12.31 },
    { boardSize: '9×9', value: 14.77 },
    { boardSize: '10×10', value: 16.32 },
    { boardSize: '11×11', value: 16.41 },
    { boardSize: '12×12', value: 17.99 },
    { boardSize: '13×13', value: 19.69 },
    { boardSize: '14×14', value: 19.68 },
    { boardSize: '15×15', value: 21.39 },
    { boardSize: '16×16', value: 22.97 }
  ],
  CHL: [ // Chancellor
    { boardSize: '8×8', value: 11.81 },
    { boardSize: '9×9', value: 13.53 },
    { boardSize: '10×10', value: 13.56 },
    { boardSize: '11×11', value: 13.14 },
    { boardSize: '12×12', value: 13.19 },
    { boardSize: '13×13', value: 13.24 },
    { boardSize: '14×14', value: 12.93 },
    { boardSize: '15×15', value: 12.99 },
    { boardSize: '16×16', value: 13.04 }
  ],
  EPR: [ // Emperor
    { boardSize: '8×8', value: 5.19 },
    { boardSize: '9×9', value: 5.21 },
    { boardSize: '10×10', value: 5.22 },
    { boardSize: '11×11', value: 5.11 },
    { boardSize: '12×12', value: 5.14 },
    { boardSize: '13×13', value: 5.16 },
    { boardSize: '14×14', value: 5.07 },
    { boardSize: '15×15', value: 5.09 },
    { boardSize: '16×16', value: 5.11 }
  ],
  QUN: [ // Queen
    { boardSize: '8×8', value: 9.00 },
    { boardSize: '9×9', value: 10.68 },
    { boardSize: '10×10', value: 12.22 },
    { boardSize: '11×11', value: 12.54 },
    { boardSize: '12×12', value: 14.08 },
    { boardSize: '13×13', value: 15.76 },
    { boardSize: '14×14', value: 15.92 },
    { boardSize: '15×15', value: 17.60 },
    { boardSize: '16×16', value: 19.15 }
  ],
  DUK: [ // Duke
    { boardSize: '8×8', value: 8.47 },
    { boardSize: '9×9', value: 9.47 },
    { boardSize: '10×10', value: 9.48 },
    { boardSize: '11×11', value: 9.29 },
    { boardSize: '12×12', value: 9.32 },
    { boardSize: '13×13', value: 9.34 },
    { boardSize: '14×14', value: 9.20 },
    { boardSize: '15×15', value: 9.23 },
    { boardSize: '16×16', value: 9.25 }
  ],
  KNG: [ // King
    { boardSize: '8×8', value: 3.15 },
    { boardSize: '9×9', value: 3.16 },
    { boardSize: '10×10', value: 3.16 },
    { boardSize: '11×11', value: 3.10 },
    { boardSize: '12×12', value: 3.11 },
    { boardSize: '13×13', value: 3.11 },
    { boardSize: '14×14', value: 3.07 },
    { boardSize: '15×15', value: 3.08 },
    { boardSize: '16×16', value: 3.08 }
  ],
  FTS: [ // Fortress
    { boardSize: '8×8', value: 9.56 },
    { boardSize: '9×9', value: 11.44 },
    { boardSize: '10×10', value: 12.53 },
    { boardSize: '11×11', value: 12.48 },
    { boardSize: '12×12', value: 13.61 },
    { boardSize: '13×13', value: 14.72 },
    { boardSize: '14×14', value: 14.71 },
    { boardSize: '15×15', value: 15.84 },
    { boardSize: '16×16', value: 16.96 }
  ],
  CDL: [ // Citadel
    { boardSize: '8×8', value: 8.88 },
    { boardSize: '9×9', value: 10.22 },
    { boardSize: '10×10', value: 10.27 },
    { boardSize: '11×11', value: 9.89 },
    { boardSize: '12×12', value: 9.96 },
    { boardSize: '13×13', value: 10.02 },
    { boardSize: '14×14', value: 9.73 },
    { boardSize: '15×15', value: 9.80 },
    { boardSize: '16×16', value: 9.86 }
  ],
  CTL: [ // Cathedral
    { boardSize: '8×8', value: 7.07 },
    { boardSize: '9×9', value: 7.09 },
    { boardSize: '10×10', value: 7.10 },
    { boardSize: '11×11', value: 6.82 },
    { boardSize: '12×12', value: 6.85 },
    { boardSize: '13×13', value: 6.88 },
    { boardSize: '14×14', value: 6.67 },
    { boardSize: '15×15', value: 6.71 },
    { boardSize: '16×16', value: 6.74 }
  ],
  CSL: [ // Castle
    { boardSize: '8×8', value: 6.00 },
    { boardSize: '9×9', value: 7.08 },
    { boardSize: '10×10', value: 8.16 },
    { boardSize: '11×11', value: 8.36 },
    { boardSize: '12×12', value: 9.45 },
    { boardSize: '13×13', value: 10.53 },
    { boardSize: '14×14', value: 10.71 },
    { boardSize: '15×15', value: 11.80 },
    { boardSize: '16×16', value: 12.89 }
  ],
  ARM: [ // Armory
    { boardSize: '8×8', value: 5.55 },
    { boardSize: '9×9', value: 6.15 },
    { boardSize: '10×10', value: 6.19 },
    { boardSize: '11×11', value: 6.05 },
    { boardSize: '12×12', value: 6.09 },
    { boardSize: '13×13', value: 6.12 },
    { boardSize: '14×14', value: 6.01 },
    { boardSize: '15×15', value: 6.05 },
    { boardSize: '16×16', value: 6.08 }
  ],
  ABY: [ // Abbey
    { boardSize: '8×8', value: 4.07 },
    { boardSize: '9×9', value: 4.10 },
    { boardSize: '10×10', value: 4.13 },
    { boardSize: '11×11', value: 4.03 },
    { boardSize: '12×12', value: 4.06 },
    { boardSize: '13×13', value: 4.08 },
    { boardSize: '14×14', value: 4.01 },
    { boardSize: '15×15', value: 4.03 },
    { boardSize: '16×16', value: 4.05 }
  ],
  POP: [ // Pope
    { boardSize: '8×8', value: 6.56 },
    { boardSize: '9×9', value: 7.96 },
    { boardSize: '10×10', value: 8.43 },
    { boardSize: '11×11', value: 8.30 },
    { boardSize: '12×12', value: 8.80 },
    { boardSize: '13×13', value: 9.42 },
    { boardSize: '14×14', value: 9.22 },
    { boardSize: '15×15', value: 9.85 },
    { boardSize: '16×16', value: 10.34 }
  ],
  ARB: [ // Archbishop
    { boardSize: '8×8', value: 6.26 },
    { boardSize: '9×9', value: 7.38 },
    { boardSize: '10×10', value: 7.37 },
    { boardSize: '11×11', value: 7.09 },
    { boardSize: '12×12', value: 7.11 },
    { boardSize: '13×13', value: 7.12 },
    { boardSize: '14×14', value: 6.92 },
    { boardSize: '15×15', value: 6.94 },
    { boardSize: '16×16', value: 6.96 }
  ],
  CRD: [ // Cardinal
    { boardSize: '8×8', value: 4.67 },
    { boardSize: '9×9', value: 4.64 },
    { boardSize: '10×10', value: 4.62 },
    { boardSize: '11×11', value: 4.41 },
    { boardSize: '12×12', value: 4.41 },
    { boardSize: '13×13', value: 4.41 },
    { boardSize: '14×14', value: 4.26 },
    { boardSize: '15×15', value: 4.27 },
    { boardSize: '16×16', value: 4.28 }
  ],
  BSP: [ // Bishop
    { boardSize: '8×8', value: 3.00 },
    { boardSize: '9×9', value: 3.60 },
    { boardSize: '10×10', value: 4.06 },
    { boardSize: '11×11', value: 4.18 },
    { boardSize: '12×12', value: 4.64 },
    { boardSize: '13×13', value: 5.23 },
    { boardSize: '14×14', value: 5.22 },
    { boardSize: '15×15', value: 5.80 },
    { boardSize: '16×16', value: 6.26 }
  ],
  PRS: [ // Priest
    { boardSize: '8×8', value: 2.93 },
    { boardSize: '9×9', value: 3.31 },
    { boardSize: '10×10', value: 3.29 },
    { boardSize: '11×11', value: 3.25 },
    { boardSize: '12×12', value: 3.23 },
    { boardSize: '13×13', value: 3.22 },
    { boardSize: '14×14', value: 3.19 },
    { boardSize: '15×15', value: 3.18 },
    { boardSize: '16×16', value: 3.18 }
  ],
  NUN: [ // Nun
    { boardSize: '8×8', value: 1.67 },
    { boardSize: '9×9', value: 1.66 },
    { boardSize: '10×10', value: 1.65 },
    { boardSize: '11×11', value: 1.62 },
    { boardSize: '12×12', value: 1.62 },
    { boardSize: '13×13', value: 1.61 },
    { boardSize: '14×14', value: 1.60 },
    { boardSize: '15×15', value: 1.59 },
    { boardSize: '16×16', value: 1.59 }
  ],
  MSL: [ // Marshall
    { boardSize: '8×8', value: 6.90 },
    { boardSize: '9×9', value: 8.42 },
    { boardSize: '10×10', value: 8.44 },
    { boardSize: '11×11', value: 7.97 },
    { boardSize: '12×12', value: 8.03 },
    { boardSize: '13×13', value: 8.09 },
    { boardSize: '14×14', value: 7.73 },
    { boardSize: '15×15', value: 7.80 },
    { boardSize: '16×16', value: 7.86 }
  ],
  CPN: [ // Captain
    { boardSize: '8×8', value: 6.56 },
    { boardSize: '9×9', value: 7.34 },
    { boardSize: '10×10', value: 7.34 },
    { boardSize: '11×11', value: 6.91 },
    { boardSize: '12×12', value: 6.96 },
    { boardSize: '13×13', value: 6.99 },
    { boardSize: '14×14', value: 6.67 },
    { boardSize: '15×15', value: 6.72 },
    { boardSize: '16×16', value: 6.76 }
  ],
  SGT: [ // Sergeant
    { boardSize: '8×8', value: 6.34 },
    { boardSize: '9×9', value: 7.05 },
    { boardSize: '10×10', value: 7.04 },
    { boardSize: '11×11', value: 6.63 },
    { boardSize: '12×12', value: 6.67 },
    { boardSize: '13×13', value: 6.69 },
    { boardSize: '14×14', value: 6.39 },
    { boardSize: '15×15', value: 6.43 },
    { boardSize: '16×16', value: 6.47 }
  ],
  GRD: [ // Guard
    { boardSize: '8×8', value: 3.56 },
    { boardSize: '9×9', value: 4.35 },
    { boardSize: '10×10', value: 4.37 },
    { boardSize: '11×11', value: 4.13 },
    { boardSize: '12×12', value: 4.16 },
    { boardSize: '13×13', value: 4.19 },
    { boardSize: '14×14', value: 4.01 },
    { boardSize: '15×15', value: 4.04 },
    { boardSize: '16×16', value: 4.07 }
  ],
  ARC: [ // Archer
    { boardSize: '8×8', value: 3.34 },
    { boardSize: '9×9', value: 4.07 },
    { boardSize: '10×10', value: 4.07 },
    { boardSize: '11×11', value: 3.84 },
    { boardSize: '12×12', value: 3.87 },
    { boardSize: '13×13', value: 3.90 },
    { boardSize: '14×14', value: 3.72 },
    { boardSize: '15×15', value: 3.76 },
    { boardSize: '16×16', value: 3.78 }
  ],
  KNT: [ // Knight
    { boardSize: '8×8', value: 3.00 },
    { boardSize: '9×9', value: 2.99 },
    { boardSize: '10×10', value: 2.97 },
    { boardSize: '11×11', value: 2.79 },
    { boardSize: '12×12', value: 2.79 },
    { boardSize: '13×13', value: 2.80 },
    { boardSize: '14×14', value: 2.67 },
    { boardSize: '15×15', value: 2.68 },
    { boardSize: '16×16', value: 2.69 }
  ],
  CTP: [ // Catapult
    { boardSize: '8×8', value: 6.12 },
    { boardSize: '9×9', value: 7.12 },
    { boardSize: '10×10', value: 7.73 },
    { boardSize: '11×11', value: 8.20 },
    { boardSize: '12×12', value: 8.82 },
    { boardSize: '13×13', value: 9.44 },
    { boardSize: '14×14', value: 9.93 },
    { boardSize: '15×15', value: 10.55 },
    { boardSize: '16×16', value: 11.17 }
  ],
  RAM: [ // Ram
    { boardSize: '8×8', value: 5.73 },
    { boardSize: '9×9', value: 6.42 },
    { boardSize: '10×10', value: 6.76 },
    { boardSize: '11×11', value: 6.98 },
    { boardSize: '12×12', value: 7.33 },
    { boardSize: '13×13', value: 7.68 },
    { boardSize: '14×14', value: 7.93 },
    { boardSize: '15×15', value: 8.29 },
    { boardSize: '16×16', value: 8.64 }
  ],
  MAC: [ // Mace
    { boardSize: '8×8', value: 4.66 },
    { boardSize: '9×9', value: 4.65 },
    { boardSize: '10×10', value: 4.64 },
    { boardSize: '11×11', value: 4.53 },
    { boardSize: '12×12', value: 4.53 },
    { boardSize: '13×13', value: 4.53 },
    { boardSize: '14×14', value: 4.46 },
    { boardSize: '15×15', value: 4.47 },
    { boardSize: '16×16', value: 4.47 }
  ],
  LNC: [ // Lance
    { boardSize: '8×8', value: 4.17 },
    { boardSize: '9×9', value: 4.91 },
    { boardSize: '10×10', value: 5.26 },
    { boardSize: '11×11', value: 5.49 },
    { boardSize: '12×12', value: 5.86 },
    { boardSize: '13×13', value: 6.22 },
    { boardSize: '14×14', value: 6.47 },
    { boardSize: '15×15', value: 6.84 },
    { boardSize: '16×16', value: 7.20 }
  ],
  HCT: [ // Hatchet
    { boardSize: '8×8', value: 3.72 },
    { boardSize: '9×9', value: 4.08 },
    { boardSize: '10×10', value: 4.09 },
    { boardSize: '11×11', value: 3.98 },
    { boardSize: '12×12', value: 4.00 },
    { boardSize: '13×13', value: 4.01 },
    { boardSize: '14×14', value: 3.93 },
    { boardSize: '15×15', value: 3.94 },
    { boardSize: '16×16', value: 3.96 }
  ],
  SWD: [ // Sword
    { boardSize: '8×8', value: 2.87 },
    { boardSize: '9×9', value: 2.86 },
    { boardSize: '10×10', value: 2.85 },
    { boardSize: '11×11', value: 2.77 },
    { boardSize: '12×12', value: 2.77 },
    { boardSize: '13×13', value: 2.77 },
    { boardSize: '14×14', value: 2.71 },
    { boardSize: '15×15', value: 2.72 },
    { boardSize: '16×16', value: 2.72 }
  ],
  AGL: [ // Angel
    { boardSize: '8×8', value: 6.69 },
    { boardSize: '9×9', value: 7.68 },
    { boardSize: '10×10', value: 8.68 },
    { boardSize: '11×11', value: 9.35 },
    { boardSize: '12×12', value: 10.35 },
    { boardSize: '13×13', value: 11.34 },
    { boardSize: '14×14', value: 12.01 },
    { boardSize: '15×15', value: 13.01 },
    { boardSize: '16×16', value: 14.00 }
  ],
  SNT: [ // Saint
    { boardSize: '8×8', value: 6.01 },
    { boardSize: '9×9', value: 6.31 },
    { boardSize: '10×10', value: 6.61 },
    { boardSize: '11×11', value: 6.69 },
    { boardSize: '12×12', value: 6.99 },
    { boardSize: '13×13', value: 7.28 },
    { boardSize: '14×14', value: 7.41 },
    { boardSize: '15×15', value: 7.70 },
    { boardSize: '16×16', value: 7.98 }
  ],
  WZD: [ // Wizard
    { boardSize: '8×8', value: 5.73 },
    { boardSize: '9×9', value: 5.76 },
    { boardSize: '10×10', value: 5.78 },
    { boardSize: '11×11', value: 5.61 },
    { boardSize: '12×12', value: 5.64 },
    { boardSize: '13×13', value: 5.67 },
    { boardSize: '14×14', value: 5.54 },
    { boardSize: '15×15', value: 5.57 },
    { boardSize: '16×16', value: 5.60 }
  ],
  SQR: [ // Squire
    { boardSize: '8×8', value: 3.72 },
    { boardSize: '9×9', value: 3.71 },
    { boardSize: '10×10', value: 3.70 },
    { boardSize: '11×11', value: 3.68 },
    { boardSize: '12×12', value: 3.68 },
    { boardSize: '13×13', value: 3.67 },
    { boardSize: '14×14', value: 3.66 },
    { boardSize: '15×15', value: 3.66 },
    { boardSize: '16×16', value: 3.65 }
  ],
  KNV: [ // Knave
    { boardSize: '8×8', value: 2.48 },
    { boardSize: '9×9', value: 2.47 },
    { boardSize: '10×10', value: 2.47 },
    { boardSize: '11×11', value: 2.45 },
    { boardSize: '12×12', value: 2.45 },
    { boardSize: '13×13', value: 2.45 },
    { boardSize: '14×14', value: 2.44 },
    { boardSize: '15×15', value: 2.44 },
    { boardSize: '16×16', value: 2.44 }
  ],
  PWN: [ // Pawn
    { boardSize: '8×8', value: 1.00 },
    { boardSize: '9×9', value: 1.00 },
    { boardSize: '10×10', value: 1.00 },
    { boardSize: '11×11', value: 1.00 },
    { boardSize: '12×12', value: 1.00 },
    { boardSize: '13×13', value: 1.00 },
    { boardSize: '14×14', value: 1.00 },
    { boardSize: '15×15', value: 1.00 },
    { boardSize: '16×16', value: 1.00 }
  ]
};

// Helper function to get piece values by abbreviation
export const getPieceValues = (abbreviation: string): BoardSizeValue[] => {
  return PIECE_VALUES[abbreviation] || [];
};